export default __webpack_public_path__ + "static/media/img.2bdbcb20.png";